<template>
  <div class="content-wrap">
    <div class="setting-box">
      <div class="tab-wrap">
        <div class="tab-item" 
          :class="idx === tabActive ? 'active' : ''" 
          v-for="(item, idx) in categories"
          :key="idx"
          @click="onCategoryChange(item, idx)">
          {{item.name}}
          <span v-if="unReadCount[item.id]">{{unReadCount[item.id]}}</span>
        </div>
      </div>
      <div class="tab-content-wrap">
        <div class="tab-content" v-if="listData.length">
          <div class="tab-content-item notify-list">
            <div class="notify-item"
                  :class="item.isRead == 1 ? 'read' : ''"
									v-for="(item, index) in listData"
                  :key="index"
                  @click="readItem(item)">
              <div class="notify-item-time">
                <div class="notify-item-time-m">{{item._md}}</div>
                <div class="notify-item-time-y">{{item._year}}</div>
              </div>
              <div class="notify-item-info">
                <div class="notify-item-title">{{item.mailTitle}}</div>
                <div class="notify-item-desc">{{item.mailContent || '-'}}</div>
              </div>
            </div>
            <Pagination :currentPage="currentPage" :total="total" @change="pageChange" />
          </div>
        </div>
        <Empty v-else />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import router from '@/router';
import { mapActions } from 'vuex';
import Pagination from '@/components/Pagination';
import { getMsgList, getUnReadTotal, readMail } from './service/api';

export default {
  data() {
    return {
      tabActive: 0,
			categories: [
			  {
			    name: "学会通知",
			    id: 5001,
			  },
			  {
			    name: "活动消息",
			    id: 5002,
			  },
			  {
			    name: "投稿消息",
			    id: 5003,
			  },
			  {
			    name: "其它",
			    id: 5004,
			  }
			],
      unReadCount: {},
			listData: [],
      currentPage: 1,
			pageSize: 10,
			total: 0
    }
  },
	props: ['cId'],
  components: {
    Pagination
  },
	watch: {
		cId(v) {
			if (v) {
				this.init();
			}
		}
	},
	mounted() {
		this.init();
	},
  methods: {
    ...mapActions(['getUnReadCount']),
		init() {
			const cId = router.currentRoute.query.t;
			const index = this.categories.findIndex(c => c.id == cId);
			if (cId && index !== -1) {
				this.tabActive = index;
			}
			this.getData();
		},
		getData() {
			const typeDicKey = this.categories[this.tabActive].id;
			const params = {
			  current: this.currentPage,
			  pageSize: this.pageSize,
			  typeDicKey,
			};
      Promise.all([getMsgList(params), getUnReadTotal()])
        .then(([res, totals]) => {
          this.total = res.totalResult;
          this.listData = (res.list || []).map((item) => {
            const date = moment(item.createTime*1000);
            item._year = date.format("YYYY");
            item._md = date.format('MM-DD');
            return item;
          });
          this.unReadCount = (totals || []).reduce((obj, item) => {
            obj[item.type_dic_key] = item.cnt;
            return obj;
          }, {});
        });
		},
		onCategoryChange(item, idx) {
			this.tabActive = idx;
			this.currentPage = 1;
		  this.getData();
		},
    readItem(item) {
      readMail({
        id: item.id
      }).then(() => {
        item.isRead = '1';
        this.getUnReadCount();
        getUnReadTotal().then(res => {
          this.unReadCount = (res || []).reduce((obj, item) => {
            obj[item.type_dic_key] = item.cnt;
            return obj;
          }, {});
        })
      }).catch(error => {
        this.$message({
          type: 'error',
          content: error
        })
      })
    },
    pageChange(page) {
      this.currentPage = page;
			this.getData();
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/less/global.less';
.setting-box {
  padding: 40px;
  min-height: 500px;
  background: #FFFFFF;
  margin-bottom: 12px;
}
.tab-wrap {
  border-bottom: 1px solid #EEEEEE;
  display: flex;

  .tab-item {
    position: relative;
    margin-right: 80px;
    padding-bottom: 19px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #131415;
    border-bottom: 1px solid transparent;
    cursor: pointer;
    
    &:hover, &.active {
      color: #06AE63;
      border-bottom: 1px solid #06AE63;
    }

    > span {
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      color: #fff;
      position: absolute;
      right: -12px;
      top: -12px;
      background: #FF3B2F;
      border-radius: 50%;
      font-size: 12px;
    }
  }
}
.tab-content-wrap {
  width: 100%;
  overflow: hidden;

  .tab-content {
    width: 400%;
    display: flex;
    transform: translateX(0);
    transition: all .5s;

    &.tab-content-1 {
      transform: translateX(-25%);
    }

    &.tab-content-2 {
      transform: translateX(-50%);
    }

    &.tab-content-3 {
      transform: translateX(-75%);
    }

    &-item {
      width: 25%;
    }
  }
}
.notify-list {

  .notify-item {
    padding: 20px 0;
    display: flex;
    cursor: pointer;

    &.read {
      color: #BBBBBB;

      &:hover {
        .notify-item-title {
          color: #BBBBBB;
        }
      }

      .notify-item-time-m, .notify-item-time-y, .notify-item-title, .notify-item-desc {
        color: #BBBBBB;
      }
    }

    &:hover {
      .notify-item-title {
        color: #06AE63;
      }
    }

    &-time {
      width: 120px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        width: 30px;
        height: 2px;
        background: #BBBBBB;
        right: 10px;
        top: 22px;
        transform: translateY(-1px);
      }

      &-m {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #B7B7B7;
        margin-bottom: 10px;
      }
      &-y {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #787878;
      }
    }

    &-info {
      flex: 1;
    }

    &-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #131415;
      line-height: 25px;
      font-weight: bold;
      margin-bottom: 3px;
    }

    &-desc {
      min-height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 400;
      color: #787878;
      line-height: 24px;
    }
  }
}
.organization-item {
  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .search-box {
      display: flex;
      align-items: center;

      .search-input-box {
        padding: 0 16px;
        height: 30px;
        background: #F5F5F5;

        input {
          width: 300px;
          height: 100%;
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #131415;
        }
      }

      .search-btn {
        width: 80px;
        height: 30px;
        cursor: pointer;
        background: #06AE63;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          width: 24px;
          height: 24px;
          margin-right: 4px;
          background: url(../../assets/images/icon-search.png) no-repeat center
            center;
          background-size: 100% 100%;
        }

        span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
      }
    }

    .search-header-extra {
      margin-left: auto;
      
      .add-contact {
        padding-left: 22px;
        cursor: pointer;
        background: url(../../assets/images/icon-add.png) no-repeat 0
          center;
        background-size: 18px 18px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #06AE63;
      }
    }
  }

  .table-wrap {
    width: 100%;

    thead {
      height: 50px;
      background: #F1F1F1;

      th {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #131415;
        line-height: 50px;
      }
    }

    tbody {
      padding: 16px 0;

      tr {
        td {
          height: 46px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #131415;
          text-align: center;
          line-height: 46px;
        }
      }
    }

    .table-op {

      a {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #131415;
        margin-right: 8px;
        cursor: pointer;

        &:hover {
          color: #06AE63;
        }

        &.del {
          &:hover {
            color: #FF3B2F;
          }
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .split-line {
        margin-right: 8px;
        height: 14px;
        width: 1px;
        display: inline-block;
        margin-top: 2px;
        background: #D8D8D8;
      }
    }
  }
}
</style>